<template>
  <transition name="slide-in" :duration="1000">
    <HeaderOutline
      v-if="show"
      class="hidden fixed top-0 left-0 z-30 px-4 w-full xl1_flex xl1_justify-between xl1_items-center"
      data-testid="company-page-navigation"
    >
      <div class="flex items-center">
        <a class="mr-3" href="/">
          <VrifyLogo class="xl_mr-8 text-gray-900" alt="VRIFY Logo" width="150" />
        </a>
        <ul v-scroll-spy="112" class="mb-0 inline-flex">
          <li v-if="management"><a class="link" href="#management" @click="goTo($event, 'management')">Management</a></li>
          <li v-if="activity"><a class="link" href="#activity" @click="goTo($event, 'activity')">Activity</a></li>
          <li v-if="assets"><a class="link" href="#assets" @click="goTo($event, 'assets')">Assets</a></li>
          <li v-if="pressReleases"><a class="link" href="#press-releases" @click="goTo($event, 'press-releases')">Press Releases</a></li>
          <li v-if="stock"><a class="link" href="#stock-overview" @click="goTo($event, 'stock-overview')">Stock</a></li>
          <li v-if="investorDecks"><a class="link" href="#corporate-deck" @click="goTo($event, 'corporate-deck')">Investor 3D Presentations</a></li>
        </ul>
      </div>
    </HeaderOutline>
  </transition>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import VrifyLogo from '~/assets/images/vrify-logo.svg'
import type { Company } from '@/entities/company'

const props = defineProps({
  company: {
    type: Object as PropType<Company>,
    required: true,
  },
  show: {
    type: Boolean,
    default: true,
  },
  activity: {
    type: [Boolean, Number],
    default: false,
  },
  management: {
    type: [Boolean, Number],
    default: false,
  },
  assets: {
    type: [Boolean, Number],
    default: false,
  },
  pressReleases: {
    type: [Boolean, Number],
    default: false,
  },
  stock: {
    type: [Boolean, Number],
    default: false,
  },
  investorDecks: {
    type: [Boolean, Number],
    default: false,
  },
})

function goTo(e: Event, id: string): void {
  const element = document.getElementById(id)

  if (element) {
    // Firefox and safari have unpredictable jumping
    e.preventDefault()
    element.scrollIntoView(true)
  }
}
</script>

<style lang="stylus" scoped>
@css {
  .link {
    @apply block text-gray-600 py-6 mx-3 xl_mx-4 xl2_mx-6;
  }

  .active {
    margin-bottom: -2px;
    @apply border-b-2 border-copper-800 font-bold text-copper-800
  }
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.3s
  max-height: 4.5rem
}

.slide-in-enter,
.slide-in-leave-to {
  visibility: hidden
  opacity: 0
  max-height: 0
}
</style>
